import React, { useState, useEffect } from "react";
import BusinessAdditionalInfoForm from "./BusinessAdditionalInfoForm";
import { MonitoringData } from "../../../../store/common";
import { useTranslation } from "react-i18next";

const BusinessAdditionalInfo: React.FunctionComponent<{ monitoringData: MonitoringData; ensureDataFetch: any }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [showForm, setShowForm] = useState(false);
    const [personalAssets, setPersonalAssets] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [monitoringData, setMonitoringData] = useState(props.monitoringData);

    const ensureDataFetched = () => {
        setisLoading(true);
        props.ensureDataFetch();
    };

    useEffect(() => {
        const personalInformation = props.monitoringData.asset["personalInformation"];
        setPersonalAssets({ personalInfo: personalInformation, addressInfo: monitoringData.asset["addressInformation"] });
        setFormData({
            "ezshield-id": props.monitoringData.asset && props.monitoringData.asset["ezshield-id"] ? props.monitoringData.asset["ezshield-id"] : "",
            "idf-user-id": props.monitoringData.asset && props.monitoringData.asset["idf-user-id"] ? props.monitoringData.asset["idf-user-id"] : "",
            "date-of-birth": personalInformation && personalInformation["date-of-birth"] && personalInformation["date-of-birth"],
            emails: personalInformation
                ? personalInformation["additional-emails-address"]
                    ? [personalInformation["primary-email-address"], ...personalInformation["additional-emails-address"]]
                    : personalInformation["primary-email-address"]
                    ? [personalInformation["primary-email-address"]]
                    : [{ email: "" }]
                : [{ email: "" }],
            firstName: personalInformation ? personalInformation["first-name"] : "",
            lastName: personalInformation ? personalInformation["last-name"] : "",
            middleName: personalInformation ? personalInformation["middle-name"] : "",
            phone: personalInformation
                ? personalInformation["additional-phone"]
                    ? [personalInformation["primary-phone"], ...personalInformation["additional-phone"]]
                    : personalInformation["primary-phone"]
                    ? [personalInformation["primary-phone"]]
                    : [{ phone: "" }]
                : [{ phone: "" }],
            securityNumber: personalInformation ? personalInformation["ssn"] : formData.securityNumber,
            internationalSecurityNumber: personalInformation && personalInformation["monitoring-sin"] ? personalInformation["monitoring-sin"] : {},
            nationalIdentificationNumber: personalInformation && personalInformation["monitoring-nid"] ? personalInformation["monitoring-nid"] : {},
            businessCreditSafeNumber:
                personalInformation && personalInformation["business-credit-safe-number"] ? personalInformation["business-credit-safe-number"] : "",
            businessDUNSNumber: personalInformation && personalInformation["business-duns-number"] ? personalInformation["business-duns-number"] : "",
            businessFaxNumber: personalInformation && personalInformation["business-fax-number"] ? personalInformation["business-fax-number"] : "",
            businessName: personalInformation && personalInformation["business-name"] ? personalInformation["business-name"] : "",
            companyDomain: personalInformation && personalInformation["company-domain"] ? personalInformation["company-domain"] : "",
            businessEINNumber: personalInformation && personalInformation["business-ein-number"] ? personalInformation["business-ein-number"] : "",
            businessStateRegistryNumber:
                personalInformation && personalInformation["business-state-registry-number"] ? personalInformation["business-state-registry-number"] : "",
        });
        setisLoading(false);
    }, [props.monitoringData]);

    const [formData, setFormData] = useState({
        "date-of-birth": "",
        emails: [{ email: "" }],
        firstName: "",
        lastName: "",
        middleName: "",
        phone: [{ phone: "", code: "" }],
        securityNumber: "",
        "ezshield-id": "",
        "idf-user-id": "",
        internationalSecurityNumber: { sin: "" },
        nationalIdentificationNumber: { nid: "" },
        businessCreditSafeNumber: "",
        businessDUNSNumber: "",
        businessFaxNumber: "",
        businessName: "",
        companyDomain: "",
        businessEINNumber: "",
        businessStateRegistryNumber: "",
    });

    return (
        <div className={`box offset-padding ${isLoading && "loading"}`}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <em className="las la-info-circle"></em>
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title ">{tLang("additionalInformationWidget.title")}</h2>
                    </div>
                </div>
                {!showForm && (
                    <div className="box-actions" onClick={() => setShowForm(true)}>
                        <button type="button" className="btn-default btn-grey-dot" id="monitored-info-additional-info">
                            <span className="btn-text">
                                {tLang("additionalInformationWidget.editButtonText")}
                                <span className="sr-only">{tLang("additionalInformationWidget.title")}</span>
                            </span>
                            <span className="btn-icon">
                                <em className="las la-pen"></em>
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="box-content">
                {/* <!-- Grid Content --> */}
                {!showForm ? (
                    <div role="grid" className="data-grid " id="monitored-info-additional-info-grid" aria-hidden="false">
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-company-domain-name">
                                    {tLang("additionalInformationWidget.label.companyDomain")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-company-domain-name">
                                <div className="data-value">
                                    {formData.companyDomain ? formData.companyDomain : "-"}
                                </div>
                            </div>
                        </div>
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-state-registry-number">
                                    {tLang("additionalInformationWidget.label.stateRegistryNumber")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-registry-number">
                                <div className="data-value">
                                    {formData.businessStateRegistryNumber
                                        ? "*".repeat(formData.businessStateRegistryNumber.substr(0, formData.businessStateRegistryNumber.length - 4).length) +
                                          formData.businessStateRegistryNumber.substr(formData.businessStateRegistryNumber.length - 4)
                                        : "-"}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <BusinessAdditionalInfoForm refreshDataCallback={ensureDataFetched} setStatus={setShowForm} formData={formData} personalData={personalAssets} />
                )}
            </div>
        </div>
    );
};

export default BusinessAdditionalInfo;
